import { useState } from 'react'
import { Star } from 'lucide-react'
import type { QuestionProps } from '../eform.types'

export default function StarRating({  value, onChange, error }: QuestionProps) {
  const numValue = parseInt(Array.isArray(value) ? value[0] ?? '0' : value || '0', 10)
  const [hovered, setHovered] = useState(0)

  return (
    <div>
      <div className="flex gap-2">
        {[1, 2, 3, 4, 5].map((star) => {
          const isFilled = star <= (hovered || numValue)
          return (
            <button
              key={star}
              type="button"
              onClick={() => onChange(String(star))}
              onMouseEnter={() => setHovered(star)}
              onMouseLeave={() => setHovered(0)}
              className="p-1 transition-transform hover:scale-110 focus:outline-none"
            >
              <Star
                className={`h-8 w-8 transition-colors ${
                  isFilled ? 'fill-amber-400 text-amber-400' : 'fill-none text-slate-300'
                }`}
              />
            </button>
          )
        })}
      </div>
      {numValue > 0 && (
        <p className="text-xs text-slate-500 mt-1">{numValue} of 5 stars</p>
      )}
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  )
}
